const routes = [
  {
    path: "/pos/sales",
    name: "sales",
    component: () => import(/* webpackChunkName: "penjualanpos" */ '@/views/private/penjualanPos/Index.vue'),
    meta: {
      title: "Penjualan"
    },
    children: [
      {
        path: '/pos/sales/delete',
        name: 'salesdelete',
        component: () => import(/* webpackChunkName: "hapustransaksi" */ '@/views/private/penjualanPos/HapusTransaksi.vue'),
        meta: {
          title: "Hapus Transaksi"
        }
      },
      {
        path: '/pos/sales/register',
        name: 'salesregister',
        component: () => import(/* webpackChunkName: "posregister" */ '@/views/private/penjualanPos/Register.vue'),
        meta: {
          title: "POS Register"
        }
      },
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})